export class NpsDOM {
    constructor(root) {
        this.root = root;
        this.nps = root.querySelector('.nps');
        this.closeButton = root.querySelector('.nps__close-button');
        this.scores = root.querySelectorAll('.m-radio > input');
        this.comment = root.querySelector('.nps__comment');
        this.textarea = root.querySelector('.nps__comment > textarea');
        this.info = root.querySelector('.nps__comment > p');
        this.submitButton = root.querySelector('.nps__comment > button');

        // Let's make sure content is correctly loaded in the DOM before triggering animation
        setTimeout(() => {
            this.nps.classList.add('visible');
        }, 100);
    }

    addListeners(onCloseClick, onScoreClick, onSubmitClick) {
        this.onCloseClick = onCloseClick;
        this.onScoreClick = onScoreClick;
        this.onSubmitClick = onSubmitClick;

        this.closeButton.addEventListener('click', this.onCloseClick);
        this.scores.forEach((scoreElement) => {
            scoreElement.addEventListener('click', this.onScoreClick);
        });
        this.submitButton.addEventListener('click', this.onSubmitClick);
    }

    removeListeners() {
        this.closeButton.removeEventListener('click', this.onCloseClick);
        this.scores.forEach((scoreElement) => {
            scoreElement.removeEventListener('click', this.onScoreClick);
        });
        this.submitButton.removeEventListener('click', this.onSubmitClick);
    }

    closePanel() {
        this.nps.classList.remove('visible');
        // Animation is 300 ms long so waiting 500 ms before removing content should be fine
        setTimeout(() => {
            this.root.removeChild(this.nps);
        }, 500);
        this.trackHeap('NpsBannerCloses');
    }

    displayAnswer(score) {
        if (score <= 6) {
            this.info.textContent = Hop.message('nps.feedback.score.detractor.question');
        } else if (score <= 8) {
            this.info.textContent = Hop.message('nps.feedback.score.neutral.question');
        } else {
            this.info.textContent = Hop.message('nps.feedback.score.promoter.question');
        }

        this.comment.classList.remove('hidden');
        this.nps.classList.add('expanded');
        this.textarea.focus();
    }

    getScore() {
        const score = Array.from(this.scores).find((scoreElement) => scoreElement.checked);
        return score ? Number(score.getAttribute('data-score')) : null;
    }

    getComment() {
        return this.textarea.value.trim();
    }

    trackHeap(event) {
        if (window.heap) {
            window.heap.track(event);
        }
    }
}
